import { create } from "zustand";

interface DisplayPreferences {
  hideMnemonics: boolean;
  hideLicensed: boolean;
}

interface AuthState {
  role: string;
  setRole: (role: string) => void;
  auth: any;
  setAuth: (auth: any) => void;
  displayPreferences: DisplayPreferences;
  setDisplayPreferences: (prefs: DisplayPreferences) => void;
}

export const useAuthStore = create<AuthState>((set, get) => ({
  role: 'USER', // Default role
  setRole: (role) => set({ role }),
  auth: null,
  setAuth: (auth) => set({ auth }),
  displayPreferences: { hideMnemonics: true, hideLicensed: true },
  setDisplayPreferences: (displayPreferences) => set({ displayPreferences }),
}));

